<template>
  <section id="wc">
    <div class="container">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="row">
          <aside
            class="wc-sidebar col-xs-4 col-md-12 col-lg-3 col-xl-3 mb-5 mt-3"
          >
            <nav
              class="
                navbar navbar-expand-lg navbar-light
                bg-light
                flex-md-column flex-row
                align-items-left
                p-3
                text-center
                sticky-top
                wc-navbar
              "
              id="wc-sidebar-menu"
            >
              <div class="px-3 pt-2 d-flex align-items-center mb-3 wc-sidebar-header">
                <img
                  src="@/assets/images/avatar.svg"
                  alt="profile picture"
                  class="img-fluid rounded-circle  p-1"
                />
                <a href="#" class="navbar-brand ps-2 text-start">
                  <p class="account-name mb-0">
                    {{ accountName }}
                  </p>
                  <p class="account-number mb-0">
                    +{{ accountPhoneNumber }}
                  </p>
                </a>
              </div>
              <button
                type="button"
                class="navbar-toggler wc-navbar-toggler border-0 order-1"
                data-bs-toggle="collapse"
                data-bs-target="#wc-nav"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div
                class="navbar-collapse collapse order-last w-100 border-0"
                id="wc-nav"
              >
                <ul
                  class="
                    navbar-nav
                    nav nav-pills
                    flex-column
                    w-100
                    justify-content-center
                    text-start
                    px-3
                  "
                >
                  <li class="nav-item p-3 d-flex align-items-center d-lg-none mb-4">
                    <img
                      src="@/assets/images/avatar.svg"
                      alt="profile picture"
                      class="img-fluid rounded-circle  p-1"
                    />
                    <a
                      href="#"
                      class="
                        navbar-brand
                        mx-0
                        font-weight-bold
                        text-wrap
                        ps-2
                        text-start
                      "
                    >
                      <span class="text-main font-size-default d-block mb-0">
                        {{ accountName }}
                      </span>
                    </a>
                  </li>
                  <li class="nav-item mb-2">
                    <router-link
                      to="/profile/get-insurance"
                      class="
                        btn-main btn-default btn-hover cursor-pointer d-inline-block  text-center buy-ins-btn
                      "
                    >
                      <img
                        src="@/assets/images/plus-rounded.svg"
                        class="align-baseline ps-1"
                      />
                      <span class="ps-2  align-text-bottom">
                        Sığorta al
                      </span>
                    </router-link>
                  </li>
                  <li class="nav-item mb-3 mt-3">
                    <router-link
                      to="/profile/contracts/cmtpl/active"
                      class="nav-link wc-nav-link wc-nav-link-contract d-flex"
                      :class="{ active: isActive(`/profile/contracts/cmtpl`)}"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 13H8M2 9L4 10L5.27064 6.18807C5.53292 5.40125 5.66405 5.00784 5.90729 4.71698C6.12208 4.46013 6.39792 4.26132 6.70951 4.13878C7.06236 4 7.47705 4 8.30643 4H15.6936C16.523 4 16.9376 4 17.2905 4.13878C17.6021 4.26132 17.8779 4.46013 18.0927 4.71698C18.3359 5.00784 18.4671 5.40125 18.7294 6.18807L20 10L22 9M16 13H19M6.8 10H17.2C18.8802 10 19.7202 10 20.362 10.327C20.9265 10.6146 21.3854 11.0735 21.673 11.638C22 12.2798 22 13.1198 22 14.8V17.5C22 17.9647 22 18.197 21.9616 18.3902C21.8038 19.1836 21.1836 19.8038 20.3902 19.9616C20.197 20 19.9647 20 19.5 20H19C17.8954 20 17 19.1046 17 18C17 17.7239 16.7761 17.5 16.5 17.5H7.5C7.22386 17.5 7 17.7239 7 18C7 19.1046 6.10457 20 5 20H4.5C4.03534 20 3.80302 20 3.60982 19.9616C2.81644 19.8038 2.19624 19.1836 2.03843 18.3902C2 18.197 2 17.9647 2 17.5V14.8C2 13.1198 2 12.2798 2.32698 11.638C2.6146 11.0735 3.07354 10.6146 3.63803 10.327C4.27976 10 5.11984 10 6.8 10Z" stroke="#596171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="ins-nav-item nav-cmtpl-item ps-2"><span>Avto-İcbari</span>
                         <span v-if="cmtplCount>0" class="ins-count ins-count-cmtpl">
                          {{cmtplCount}}
                        </span>
                      </div>
                    </router-link>
                  </li>
                  <li class="nav-item mb-3">
                    <router-link
                      to="/profile/contracts/travel/active"
                      class="nav-link wc-nav-link wc-nav-link-reload-contract d-flex"
                      :class="{ active: isActive(`/profile/contracts/travel`)  }"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.7447 2.81286C18.7095 1.81638 20.3035 1.80349 21.2843 2.78424C22.2381 3.73811 22.2559 5.27908 21.3242 6.25469L18.5456 9.16445C18.3278 9.39252 18.2189 9.50656 18.1518 9.64012C18.0924 9.75835 18.057 9.8872 18.0478 10.0192C18.0373 10.1683 18.0728 10.3219 18.1437 10.6292L19.8716 18.1168C19.9444 18.4322 19.9808 18.5899 19.969 18.7425C19.9586 18.8775 19.9209 19.009 19.8582 19.129C19.7873 19.2646 19.6728 19.379 19.4439 19.6079L19.0732 19.9787C18.467 20.5848 18.164 20.8879 17.8538 20.9428C17.5829 20.9907 17.3043 20.9249 17.0834 20.7609C16.8305 20.5731 16.695 20.1665 16.4239 19.3533L14.4141 13.324L11.0688 16.6693C10.8691 16.869 10.7693 16.9689 10.7025 17.0864C10.6433 17.1906 10.6034 17.3045 10.5845 17.4228C10.5632 17.5564 10.5788 17.6967 10.61 17.9774L10.7937 19.6308C10.8249 19.9115 10.8405 20.0518 10.8192 20.1853C10.8003 20.3036 10.7603 20.4176 10.7012 20.5217C10.6344 20.6393 10.5345 20.7392 10.3348 20.9388L10.1373 21.1363C9.66428 21.6094 9.42775 21.8459 9.1649 21.9144C8.93436 21.9745 8.68993 21.9503 8.47565 21.8462C8.23134 21.7275 8.04579 21.4491 7.67469 20.8925L6.10637 18.54C6.04007 18.4406 6.00692 18.3908 5.96843 18.3457C5.93424 18.3057 5.89694 18.2684 5.85688 18.2342C5.81178 18.1957 5.76206 18.1626 5.66261 18.0963L3.31012 16.5279C2.75348 16.1568 2.47515 15.9713 2.35643 15.727C2.2523 15.5127 2.2281 15.2683 2.28818 15.0377C2.35668 14.7749 2.59321 14.5383 3.06627 14.0653L3.26378 13.8678C3.46346 13.6681 3.56331 13.5682 3.68089 13.5015C3.78505 13.4423 3.899 13.4023 4.0173 13.3834C4.15083 13.3622 4.29117 13.3777 4.57184 13.4089L6.22523 13.5926C6.5059 13.6238 6.64623 13.6394 6.77977 13.6181C6.89807 13.5993 7.01202 13.5593 7.11618 13.5001C7.23376 13.4333 7.3336 13.3335 7.53329 13.1338L10.8786 9.78848L4.84933 7.77872C4.0361 7.50764 3.62949 7.3721 3.44169 7.11919C3.27771 6.89836 3.21193 6.61972 3.25984 6.34886C3.31471 6.03867 3.61778 5.7356 4.22393 5.12945L4.5947 4.75868C4.82359 4.52979 4.93804 4.41534 5.07363 4.34445C5.19364 4.28171 5.32514 4.24399 5.46017 4.23359C5.61272 4.22184 5.77043 4.25824 6.08584 4.33103L13.545 6.05236C13.8549 6.12389 14.0099 6.15966 14.1595 6.14902C14.304 6.13874 14.4445 6.09721 14.5713 6.0273C14.7027 5.95488 14.8133 5.84062 15.0346 5.61208L17.7447 2.81286Z" stroke="#596171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <div class="ins-nav-item nav-travel-item ps-2"><span>Səfər</span>
                          <span v-if="travelCount>0" class="ins-count ins-count-travel">
                          {{ travelCount }}</span>
                        </div>
                    </router-link>
                  </li>
                  <li class="nav-item mb-3">
                    <router-link
                      to="/profile"
                      class="nav-link wc-nav-link wc-nav-link-user"
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <ellipse cx="12" cy="17.5" rx="7" ry="3.5" stroke="#596171" stroke-width="1.5" stroke-linejoin="round"/>
                        <circle cx="12" cy="7" r="4" stroke="#596171" stroke-width="1.5" stroke-linejoin="round"/>
                      </svg>
                      <span class="ps-2">Şəxsi məlumatlar</span>
                    </router-link>
                  </li>
                  <li class="nav-item logout">
                    <a
                      href="#"
                      class="nav-link wc-nav-link wc-nav-link-exit text-main"
                      @click.prevent="logout"
                    >
                      <img src="@/assets/images/logout.svg" />
                      <span class="ps-2">Çıxış</span>
                    </a>
                  </li>
                </ul>
              </div>
            </nav>
          </aside>
          <main
            class="
              tab-content
              col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-9
              h-100
              mt-3
            "
          >
            <router-view :key="$route.fullPath" />
          </main>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import authService from "@/services/auth.service";
import api from "@/api/travel.api";
import apiCmtpl from "@/api/cmtpl.api";

export default {
  data: () => ({
    isLoading: false,
    contractsOfTravel: [],
    contractsOfCmtpl: [],
    isDataExist:false,
    cmtplCount:0,
    travelCount:0
  }),
  computed: {
    accountName() {
      return localStorage.getItem("account_name");
    },
    accountPhoneNumber() {
      return localStorage.getItem("account_phoneNumber");
    },
  },
  created() {
    this.loadData();
    this.loadCmtplData();
  },
  methods: {
    logout() {
      authService.logout();
      location.href = "/";
    },
    isActive(route) {
      return this.$route.path.startsWith(route);
    },

     loadData() {
      this.isLoading = true;

       api.getActiveContracts()
       .then((data) => {
          this.contractsOfTravel = data;
          this.travelCount = this.contractsOfTravel.filter(
            (contract) => contract.status === 1 || contract.status === 3
          ).length;
        })
        .catch((error) => this.emitter.emit("error", error))
        .finally(() => (this.isLoading = false));

    },

    loadCmtplData() {
      this.isLoading = true;

      apiCmtpl.getActiveContracts()
        .then((data) => {
          this.contractsOfCmtpl=data;
          this.cmtplCount = this.contractsOfCmtpl.filter(
            (contract) => contract.status === 1 || contract.status === 6
          ).length;
        })
        .catch((error) => this.emitter.emit("error", error))
        .finally(() => (this.isLoading = false));
    },

  }
};
</script>